import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_KEYS } from "utils/siteAssets";

function LandingFooter() {
  const year = new Date().getFullYear();
  const { getAssetUrl } = useSiteAssets();
  const logoUrl = getAssetUrl(SITE_ASSET_KEYS.LOGO_APLIKASI);

  return (
    <MDBox component="footer" bgColor="dark" color="white" pt={6} pb={3}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <MDBox display="flex" alignItems="center" gap={1.5} mb={2}>
              <MDBox component="img" src={logoUrl} alt="Logo" width="3rem" />
              <MDBox>
                <MDTypography variant="h6" color="white" fontWeight="bold" lineHeight={1.2}>
                  DPMPTSP
                </MDTypography>
                <MDTypography variant="caption" color="white" opacity={0.8}>
                  Kabupaten Rote Ndao
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDTypography variant="body2" color="white" opacity={0.75}>
              Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kabupaten Rote Ndao —
              mewujudkan pelayanan perizinan yang cepat, mudah, dan transparan melalui TIALAI.
            </MDTypography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <MDTypography variant="button" color="white" fontWeight="bold" mb={1}>
              Layanan
            </MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.75} display="block" mb={0.5}>
              Perizinan Online
            </MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.75} display="block" mb={0.5}>
              Nonperizinan
            </MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.75} display="block">
              Verifikasi Dokumen Izin
            </MDTypography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <MDTypography variant="button" color="white" fontWeight="bold" mb={1}>
              Kontak
            </MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.75} display="block" mb={0.5}>
              Jl. ——, Ba'a, Kab. Rote Ndao, NTT
            </MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.75} display="block" mb={0.5}>
              Email: dpmptsp.rotenao@kab.go.id
            </MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.75} display="block">
              Senin–Jumat, 08.00–16.00 WITA
            </MDTypography>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.15)", my: 3 }} />

        <MDTypography variant="caption" color="white" opacity={0.6} textAlign="center" display="block">
          © {year} DPMPTSP Kabupaten Rote Ndao — TIALAI. Hak cipta dilindungi.
        </MDTypography>
      </Container>
    </MDBox>
  );
}

export default LandingFooter;
